var productForm = document.querySelector('product-info');

// fake btn mobile qty
var addToCartButton = document.querySelector('main .product .product-form__buttons button');
var mobileAddToCartButton = document.querySelector('.js-mobile-btn-add-to-cart');
mobileAddToCartButton.addEventListener('click', function () {
  addToCartButton.click();
});

var decreaseButton = document.querySelector('.btn-decrease');
var increaseButton = document.querySelector('.btn-increase');
var quantityInput = document.querySelector('.quantity-input');
var currentQty = document.querySelector('.product .product-form__input .quantity__input');

function updateCurrentQty(value) {
  currentQty.value = value;
  currentQty.dataset.cartQuantity = value;
}

decreaseButton.addEventListener('click', function () {
  let currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
    updateCurrentQty(quantityInput.value);
  }
});
increaseButton.addEventListener('click', function () {
  let currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
  updateCurrentQty(quantityInput.value);
});
quantityInput.addEventListener('change', function () {
  if (quantityInput.value < 1) {
    quantityInput.value = 1;
  }
  updateCurrentQty(quantityInput.value);
});

function updateQtyForm() {
  quantityInput.value = 1;
  updateCurrentQty(quantityInput.value);
}

function updateQtyForm() {
  productForm.addEventListener('change', updateQtyForm);
}
function removeQtyForm() {
  productForm.removeEventListener('change', updateQtyForm);
}

if (window.innerWidth < 1024) {
  updateQtyForm();
} else {
  removeQtyForm();
}

window.addEventListener('resize', function () {
  if (window.innerWidth < 1024) {
    updateQtyForm();
  } else {
    removeQtyForm();
  }
});

// yotpo open reviews
function yotpoDropdown() {
  var accordionYotpo = document.querySelector('#yotpo-review-toggle');

  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.addedNodes.length > 0) {
        const yotpoElement = document.querySelector('#yotpo-reviews-main-widget');
        if (yotpoElement && accordionYotpo) {
          const emptyState = document.querySelector('#yotpo-reviews-main-widget .yotpo-head');
          if (emptyState !== null) {
            observer.disconnect();
            accordionYotpo.parentNode.classList.remove('tw-hidden');
            accordionYotpo.addEventListener('click', () => {
              document.querySelector('#yotpo-reviews-main-widget').classList.toggle('open');
              accordionYotpo.querySelector('svg').classList.toggle('tw-rotate-180');
            });
          }
        }
      }
    }
  });

  observer.observe(document.querySelector('.product__info-container'), { childList: true, subtree: true });

  var productParentNoScroll = document.querySelector('.product__info-container');
  productParentNoScroll.addEventListener('click', (event) => {
    if (
      event.target.matches('.yotpo-star-distribution-value') ||
      event.target.matches('.yotpo-star-distribution') ||
      event.target.matches('.yotpo-progress-bar-score') ||
      event.target.matches('.yotpo-star-distribution-bar') ||
      event.target.matches('.yotpo-star-distribution-index-wrapper')
    ) {
      event.target.preventDefault();
      event.target.stopPropagation();
    }
  });
}
document.addEventListener('DOMContentLoaded', yotpoDropdown);

// details accordion
var detailsElements = document.querySelectorAll('details');
detailsElements.forEach(function (details) {
  details.addEventListener('toggle', function () {
    var content = details.querySelector('.accordion__content');
    if (details.open) {
      var contentHeight = content.scrollHeight + 'px';
      content.style.maxHeight = contentHeight;
    } else {
      content.style.maxHeight = '0';
    }
  });
});
